export default __webpack_public_path__ + "static/media/whatsapp-logo.ae5723a4.svg";